var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.nonZeroSelection ? _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var button = _ref.on;
        return [_c('v-tooltip', {
          attrs: {
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref2) {
              var tooltip = _ref2.on;
              return [_c('v-scroll-x-transition', [_c('v-btn', _vm._g({
                attrs: {
                  "icon": "",
                  "small": ""
                },
                on: {
                  "click": button.click
                }
              }, tooltip), [_c('v-icon', {
                attrs: {
                  "color": "primary",
                  "size": "20px"
                }
              }, [_vm._v(" mdi-tray-arrow-down ")])], 1)], 1)];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Download selected")])])];
      }
    }], null, false, 2815682821),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-0"
  }, [_c('v-card-title', {
    staticClass: "pa-4",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(" Download the following " + _vm._s(_vm.selection.length > 1 ? _vm.selection.length : '') + " " + _vm._s(_vm.downloadType) + _vm._s(_vm.plural) + "? ")]), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "color": "grey lighten-5",
      "dense": ""
    }
  }, [_vm._l(_vm.selection, function (item) {
    return [_c('v-divider', {
      key: (item + "-divider")
    }), _c('v-list-item', {
      key: item
    }, [_c('v-list-item-icon', [_c('v-icon', {
      attrs: {
        "color": "green accent-4",
        "size": "18"
      }
    }, [_vm._v(" mdi-check ")])], 1), _vm._v(" " + _vm._s(item) + " ")], 1)];
  })], 2)], 1), _c('v-divider'), _c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "active": _vm.loading
    }
  }), _c('v-card-actions', {
    staticClass: "px-4 py-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "depressed": "",
      "color": "primary",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.execute
    }
  }, [_vm._v(" yes ")]), _c('v-btn', {
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function ($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v(" cancel ")])], 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }